import React from "react";
import dayjs from "dayjs";
import { Classes } from "@blueprintjs/core";
import classNames from "classnames";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

function TimelineEvent(_ref) {
  var date = _ref.date,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "tg-timeline-event"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "tg-timeline-circle"
  }), children, /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: 5
    },
    className: classNames(Classes.TEXT_SMALL, Classes.TEXT_MUTED)
  }, "(", dayjs(date).fromNow(), ")")));
}

export default TimelineEvent;